import { render, staticRenderFns } from "./AgentPerformance.vue?vue&type=template&id=6fd90b65&"
import script from "./AgentPerformance.vue?vue&type=script&lang=js&"
export * from "./AgentPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports